import React from 'react';

import cx from 'classnames';

import s from './index.module.css';
import { ICheckboxProps } from './types';

function Checkbox({ children, checked, onClick, className }: ICheckboxProps) {
  return (
    <label className={cx(s.label, checked && s.checked, children && s.withContent, className)}>
      <input type="checkbox" checked={checked} onClick={onClick} />
      <span className={s.checkbox}>
        <span className={s.check} />
      </span>
      {children && <span>{children}</span>}
    </label>
  );
}

export default Checkbox;
